<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_joueur">Joueurs</label>
      </div>
      <select id="sanction_joueur"
              v-model="dataForm.joueur_id"
              class="custom-select"
              name="sanction_joueur">
        <option :key="joueur.joueur_id.slice(5,15)"
                :value="joueur.joueur_id"
                v-for="joueur in joueurs">
          {{ joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() }}
          {{ joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() }}
          {{ joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_carton_jaune">Carton jaune</label>
      </div>
      <input id="sanction_carton_jaune"
             v-model="dataForm.carton_jaune"
             class="form-control"
             name="sanction_carton_jaune"
             placeholder="Entrez le nombre de cartons jaune"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_carton_rouge">Carton rouge</label>
      </div>
      <input id="sanction_carton_rouge"
             v-model="dataForm.carton_rouge"
             class="form-control"
             name="sanction_carton_rouge"
             placeholder="Entrez le nombre de cartons rouge"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_match">Match</label>
      </div>
      <select id="sanction_match"
              v-model="dataForm.match_id"
              class="custom-select"
              name="sanction_match">
        <option :key="match.match_id"
                :value="match.match_id"
                v-for="match in matchs">
          {{ equipes ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_a_id )[0].nom.toUpperCase() : '' }}
          vs
          {{ equipes ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_b_id )[0].nom.toUpperCase() : '' }}
          ({{ new Date(match.date_rencontre).toLocaleDateString() }} - {{ match.temps_rencontre }})
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="sanction_raison">Causes de la sanction</label>
      </div>
      <textarea id="sanction_raison"
                v-model="dataForm.raison_sanction"
                class="form-control"
                name="sanction_raison"
                placeholder="Entrez un court commentaire sur les causes de la sanction"
                type="email">
      </textarea>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      joueurs: null,
      equipes: null,
      saisons: null,
      matchs: null,
      championnats: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        joueur_id: '',
        carton_jaune: '',
        carton_rouge: '',
        match_id: '',
        raison_sanction: '',
        table: 'sanctions',
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
    ]),
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Championnat ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du championnat !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du championnat !"
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'joueurs'
    })
        .then((data) => {
          this.joueurs = data.data
        })
        .catch((data) => {
          this.joueurs = data
        })
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'matchs_joues'
    })
        .then((data) => {
          this.matchs = data.data
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cartons/components/Create.vue